/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import moment from 'moment';

export default {
  getTopContactDataSeriesByAge: state => (age, startDate, endDate) => {
    const rawData = state.rawData;
    const genderData = { Alla: [] };
    const seriesData = [];

    const parsedStartDate = moment(startDate);
    const parsedEndDate = moment(endDate);

    let total = 0;

    //console.log('Age', age);

    rawData.forEach(element => {
      const created = moment(element.created_at);

      const inTimeRange =
        created.isSameOrAfter(parsedStartDate) &&
        created.isSameOrBefore(parsedEndDate);

      if (
        parseInt(element.Data.age) === parseInt(age) &&
        element.Data.contactSurvey &&
        Object.keys(element.Data.contactSurvey).length > 0 &&
        element.Data.formData &&
        inTimeRange
      ) {
        let gender = 'Ej angett kön';
        if (
          element.Data.formData.hasOwnProperty('gender') &&
          element.Data.formData.gender.length > 0
        ) {
          gender = element.Data.formData.gender;
        }

        if (!genderData.hasOwnProperty(gender)) {
          genderData[gender] = [element.Data.contactSurvey];
        } else {
          genderData[gender].push(element.Data.contactSurvey);
        }

        genderData['Alla'].push(element.Data.contactSurvey);
      }
    });

    const systemIndex = _makeSystemIndexDictionary(genderData['Alla']);

    for (const key in genderData) {
      seriesData.push(_makeSerieForGender(key, genderData[key], systemIndex));
    }
    console.log(seriesData);
    return seriesData;
  },
  getStatsForStory: state => storyId => {
    const rawData = state.rawData;
    let storyStats = [];

    rawData.map(obj => {
      if (obj.Data.age !== 18) {
        let stories = obj.Data.stories
          ? obj.Data.stories.filter(story => story.storyId == storyId)
          : false;
        if (Array.isArray(stories)) {
          stories.map(s => {
            storyStats.push({ ...obj.Data.formData, ...s, age: obj.Data.age });
          });
        }
      }
    });
    return storyStats;
  },
  getStoryLimitDataSeries: (state, getters) => (storyId, filter, story) => {
    let storyStats = getters.getStatsForStory(storyId);
    let dataByLimit = {};
    const seriesData = [];
    let total = 0;
    const genderData = { Alla: [] };

    if (filter.age) {
      storyStats = storyStats.filter(s => s.age === filter.age);
    }

    storyStats.forEach(element => {
      let gender = 'Ej angett kön';

      if (element.hasOwnProperty('gender') && element.gender.length > 0) {
        gender = element.gender;
      }
      if (!genderData.hasOwnProperty(gender)) {
        genderData[gender] = [element];
      } else {
        genderData[gender].push(element);
      }
      genderData['Alla'].push(element);
    });

    if (story) {
      story.Parts.map((part, index) => {
        if (!dataByLimit.hasOwnProperty(index + 1)) {
          dataByLimit[index + 1] = [];
        }
      });
      dataByLimit['alla okay'] = [];
    }

    for (const key in genderData) {
      //let genderDataByLimit = { ...dataByLimit };
      let genderDataByLimit = {};
      if (story) {
        story.Parts.map((part, index) => {
          if (!genderDataByLimit.hasOwnProperty(index + 1)) {
            genderDataByLimit[index + 1] = [];
          }
        });
        genderDataByLimit['alla okay'] = [];
      }

      let genderSeries = [];
      let genderTotal = genderData[key].length;

      genderData[key].map(item => {
        if (!genderDataByLimit.hasOwnProperty(item.limit)) {
          genderDataByLimit[item.limit] = [item];
        } else {
          genderDataByLimit[item.limit].push(item);
        }
      });

      for (const keyLimit in genderDataByLimit) {
        genderSeries.push({
          x: keyLimit,
          y: (genderDataByLimit[keyLimit].length / genderTotal) * 100
        });
      }
      seriesData.push({ data: genderSeries, name: key });
    }

    return seriesData;
  },
  getOverallStatsForStory: (state, getters) => (storyId, filter) => {
    let storyStats = getters.getStatsForStory(storyId);
    let familiarCount = 0;
    let messages = [];

    if (filter.age) {
      storyStats = storyStats.filter(s => s.age === filter.age);
    }

    familiarCount = storyStats.filter(s => s.familiar === 'ja').length;

    messages = storyStats.filter(
      s => s.storyId === storyId && s.message && s.message.length > 0
    );

    return {
      stats: [
        { label: 'Antal svar', value: storyStats.length },
        { label: 'Känner igen sig', value: familiarCount }
      ],
      messages: messages
    };
  }
};

function _makeSerieForGender(gender, data, systemIndexDict) {
  const serieData = { name: `${gender} (${data.length})`, data: [] };
  const systemData = {};
  let total = data.length;
  const systemTotal = Object.keys(systemIndexDict).length;
  const systemKeys = Object.keys(systemIndexDict);

  // Initiera data arrayen med tomma objekt
  for (let i = 0; i < systemTotal; i += 1) {
    serieData.data.push({ x: '', y: 0 });
  }

  data.forEach(survey => {
    if (!systemData.hasOwnProperty(survey['1'])) {
      systemData[survey['1']] = 1;
    } else {
      systemData[survey['1']] += 1;
    }
  });

  for (const key in systemData) {
    const systemIndex = systemKeys.findIndex(system => system == key);
    serieData.data[systemIndex] = {
      x: key,
      y: parseInt((systemData[key] / total) * 100)
    };
  }

  return serieData;
}

function _makeSystemIndexDictionary(data) {
  const systemIndex = {};
  const systemData = {};
  let total = 0;

  data.forEach(survey => {
    total += 1;
    if (!systemData.hasOwnProperty(survey['1'])) {
      systemData[survey['1']] = 1;
    } else {
      systemData[survey['1']] += 1;
    }
  });
  let index = 0;
  for (const key in systemData) {
    systemIndex[key] = index;
    index += 1;
  }

  return systemIndex;
}
